<template>
  <div>
    <v-card elevation="0">
      <v-card-title>Настройка значений</v-card-title>
      <v-card-text>
        <div
          v-for="(item, i) in valueList"
          :key="i"
          class="d-flex flex-row justify-center align-center"
        >
          <div class="mr-2">
            <v-checkbox
              v-model="item.isStops"
              label="Диапазон"
            />
          </div>
          <div class="flex-grow-1">
            <v-text-field
              v-model="item.text"
              label="Значение"
            />
          </div>
          <div class="flex-grow-1 pb-4 pl-4">
            <v-menu
              :close-on-content-click="false"
              offset-x
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :color="item.color"
                  :class="[`${getTextColor(item.color)}--text`]"
                  class="mr-4"
                  small
                  rounded
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  Выбрать цвет
                </v-btn>
              </template>

              <v-card>
                <v-color-picker
                  v-model="item.color"
                  mode="rgba"
                  flat
                />
              </v-card>
            </v-menu>
          </div>
          <div>
            <v-btn class="error" @click="remove(i)">Удалить</v-btn>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <div>
          <v-btn class="success" @click="add">Добавить</v-btn>
          <v-btn class="primary ml-2" @click="save">Сохранить</v-btn>
        </div>
      </v-card-actions>
    </v-card>
    <v-card elevation="0">
      <v-card-title>Поля для построения графиков</v-card-title>
      <v-card-text>
        <div
          v-for="(item, i) in axisLinesList"
          :key="i"
          class="d-flex flex-row justify-center align-center"
        >
          <div class="flex-grow-1">
            <v-text-field v-model="item.name" label="Название" />
          </div>
          <div class="ml-4">
            <v-btn class="error" @click="removeAxisLine(i)">Удалить</v-btn>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <div>
          <v-btn class="success" @click="addAxisLine">Добавить</v-btn>
          <v-btn class="primary ml-2" @click="save">Сохранить</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { hex2rgba, rgba2hex } from '@/utils/hex-to-rgba';
import GetTextColor from '@/utils/get-text-color';
import { saveOrUpdateRegionPresetValues } from '@/services/layers';

export default {
  name: 'value-list-tab',
  props: {
    list: Array,
    axisLines: Array,
    layerId: String,
  },
  data: () => ({
    valueList: [],
    axisLinesList: [],
  }),
  computed: {
    getTextColor() {
      return (i) => GetTextColor(i);
    },
  },
  async created() {
    this.axisLinesList = JSON.parse(JSON.stringify(this.axisLines));

    this.valueList = Array.from(this.list.map(_ => ({
      ..._,
      color: rgba2hex(_.color),
      isStops: _.isStops,
    })));
  },
  methods: {
    ...mapActions(['showNotify']),

    remove(i) {
      this.valueList.splice(i, 1);
    },

    add() {
      this.valueList.push({ text: '', color: '#00FF00FF' });
    },

    removeAxisLine(i) {
      this.axisLinesList.splice(i, 1);
    },

    addAxisLine() {
      this.axisLinesList.push({ name: '' });
    },

    async save() {
      const params = {
        list: this.valueList.map(_ => ({
          ..._,
          color: hex2rgba(_.color),
        })),

        axisLines: this.axisLinesList,
      };

      const data = await saveOrUpdateRegionPresetValues(this.layerId, params);
      this.showNotify({ message: 'Данные успешно обновлены' });

      this.valueList = data.map(_ => ({
        ..._,
        color: rgba2hex(_.color),
      }));

      this.$emit('update', this.valueList);
    },
  },
};
</script>

<style scoped>

</style>
